import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t,
    getPath
  } = useLanguage();
  return <footer className="w-full py-12 sm:py-16 border-t" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border)'
  }} data-id="element-108">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12" data-id="element-110">
          {/* Services */}
          <div data-id="element-111">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-112">
              {t('footer.services')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-113">
              <li data-id="element-114">
                <a href={getPath('#services')} className="hover:underline" data-id="element-115">
                  {t('nav.services')}
                </a>
              </li>
              <li data-id="element-116">
                <a href={getPath('#consultation')} className="hover:underline" data-id="element-117">
                  {t('nav.getStarted')}
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-118">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-119">
              {t('footer.company')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-120">
              <li data-id="element-121">
                <a href={getPath('#about')} className="hover:underline" data-id="element-122">
                  {t('footer.aboutLink')}
                </a>
              </li>
              <li data-id="element-123">
                <a href={getPath('referral')} className="hover:underline" data-id="element-124">
                  {t('nav.referral')}
                </a>
              </li>
              <li data-id="element-125">
                <a href={getPath('#faq')} className="hover:underline" data-id="element-126">
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div data-id="element-127">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-128">
              {t('footer.legal')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-129">
              <li data-id="element-130">
                <a href={getPath('privacy')} className="hover:underline" data-id="element-131">
                  {t('nav.privacy')}
                </a>
              </li>
              <li data-id="element-132">
                <a href={getPath('terms')} className="hover:underline" data-id="element-133">
                  {t('nav.terms')}
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-134">
            <h4 className="font-semibold mb-4 text-sm" style={{
            color: 'var(--text-primary)'
          }} data-id="element-135">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-2 text-xs sm:text-sm" style={{
            color: 'var(--text-secondary)'
          }} data-id="element-136">
              <li data-id="element-137">
                <a href="https://t.me/jetlyagency" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-138">
                  Telegram
                </a>
              </li>
              <li data-id="element-139">
                <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="hover:underline" data-id="element-140">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-141">
                <a href="mailto:hello@jetly.agency" className="hover:underline" data-id="element-142">
                  Email
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t flex flex-col md:flex-row items-center justify-between gap-4" style={{
        borderColor: 'var(--border)'
      }} data-id="element-143">
          <div className="flex items-center gap-2" data-id="element-144">
            <span className="text-lg sm:text-xl font-bold tracking-tight" style={{
            color: 'var(--text-primary)'
          }} data-id="element-145">
              Jetly Agency
            </span>
          </div>
          <div className="text-xs sm:text-sm text-center" style={{
          color: 'var(--text-muted)'
        }} data-id="element-146">
            © {new Date().getFullYear()} Jetly.agency. {t('footer.rights')}
          </div>
        </div>
      </div>
    </footer>;
}